/*
 * Slider functionality
 */
import KeenSlider from 'keen-slider';

export let __init_free_slider = async function () {
    // let animation = { duration: 9999999, easing: (t) => t };
    $('.stmnt-widget--slider').each(async function (index, section_slide) {
        let slide_container = $(section_slide).find('.js--custom-slider');
        let slider = new KeenSlider(
            slide_container[0],
            {
                loop: $(slide_container).attr('data-infinite') == 'true' ? true : false,
                drag: true,
                dragSpeed: $(slide_container).attr('data-drag-speed'),
                slides: {
                    perView: $(slide_container).attr('data-items-show'),
                },
                breakpoints: {
                    '(max-width: 1023px)': {
                        slides: {
                            perView: $(slide_container).attr('data-items-show-tablet'),
                        },
                    },
                    '(max-width: 639px)': {
                        slides: {
                            perView: $(slide_container).attr('data-items-show-mobile'),
                        },
                    },
                },
                mode: $(slide_container).attr('data-slider-type'),
                selector: '.keen-slider__slide',
                created: (s) => {
                    // s.moveToIdx(2, true, animation);
                },
                updated(s) {
                    // s.moveToIdx(s.track.details.abs + 2, true, animation);
                    // console.log('called updated function');
                },
                animationEnded(s) {
                    // s.moveToIdx(s.track.details.abs + 2, true, animation);
                },
            },
            [
                // add plugins here
            ]
        );

        let left_interval = undefined;
        let right_interval = undefined;

        await __slider_highlight_navigation(slider);
        await __slider_month_navigation(slider);

        $('.hover--toggle.right').hover(
            function () {
                let animation_new = { duration: 2000, easing: (t) => t };
                slider.moveToIdx(slider.track.details.abs + 2, true, animation_new);
                left_interval = setInterval(function () {
                    slider.moveToIdx(slider.track.details.abs + 2, true, animation_new);
                }, 2000);
            },
            function () {
                let animation_new = { duration: 99999999, easing: (t) => t };
                slider.moveToIdx(slider.track.details.abs + 2, true, animation_new);
                clearInterval(left_interval);
            }
        );

        $('.hover--toggle.left').hover(
            function () {
                let animation_new = { duration: 2000, easing: (t) => t };
                slider.moveToIdx(slider.track.details.abs - 2, true, animation_new);
                right_interval = setInterval(function () {
                    slider.moveToIdx(slider.track.details.abs - 2, true, animation_new);
                }, 2000);
            },
            function () {
                let animation_new = { duration: 99999999, easing: (t) => t };
                slider.moveToIdx(slider.track.details.abs - 2, true, animation_new);
                clearInterval(right_interval);
            }
        );

        // $('.stmnt-widget--slider.social').find('div[role="button"]').each(function(){
        //     if($(this).attr("href")){
        //         $(this).on("click", function(){
        //             window.open($(this).attr("href"), 'social_detail');
        //         });
        //     }
        // });

    });
};

export let __slider_widget_lists = async function () {
    let highlight_slider;
    let month_slider;

    if ($(window).width() <= 1023) {
        $('.stmnt-widget--slider').each(async function () {
            let month_list = $(this).find('.month-list');

            if ($(month_list).length) {
                month_slider = new KeenSlider(
                    month_list[0],
                    {
                        loop: false,
                        drag: true,
                        dragSpeed: 0.75,
                        slides: {
                            perView: 6,
                        },
                        breakpoints: {
                            '(max-width: 1023px)': {
                                slides: {
                                    perView: 4,
                                },
                            },
                            '(max-width: 639px)': {
                                slides: {
                                    perView: 3,
                                },
                            },
                            '(max-width: 480px)': {
                                slides: {
                                    perView: 2,
                                },
                            },
                            '(max-width: 350px)': {
                                slides: {
                                    perView: 1,
                                },
                            },
                        },
                        mode: 'free-snap',
                        selector: '.month-list-item',
                        created: (s) => {
                            // s.moveToIdx(2, true, animation);
                        },
                        updated(s) {
                            // s.moveToIdx(s.track.details.abs + 2, true, animation);
                            // console.log('called updated function');
                        },
                        animationEnded(s) {
                            // s.moveToIdx(s.track.details.abs + 2, true, animation);
                        },
                        slideChanged(s) {
                            let move_to_index = s.track.details.abs;
                            highlight_slider.moveToIdx(move_to_index);
                        },
                    },
                    [
                        // add plugins here
                    ]
                );
            }

            let highlight_list = $(this).find('.highlight-list.mobile--highlights');

            if ($(highlight_list).length) {
                highlight_slider = new KeenSlider(
                    highlight_list[0],
                    {
                        loop: false,
                        drag: true,
                        dragSpeed: 0.75,
                        slides: {
                            perView: 6,
                            origin: 0,
                        },
                        breakpoints: {
                            '(max-width: 1023px)': {
                                slides: {
                                    perView: 4,
                                },
                            },
                            '(max-width: 639px)': {
                                slides: {
                                    perView: 3,
                                },
                            },
                            '(max-width: 480px)': {
                                slides: {
                                    perView: 2,
                                },
                            },
                            '(max-width: 350px)': {
                                slides: {
                                    perView: 1,
                                },
                            },
                        },
                        mode: 'free-snap',
                        selector: '.highlight-list-item',
                        created: (s) => {
                            // s.moveToIdx(2, true, animation);
                        },
                        updated(s) {
                            // s.moveToIdx(s.track.details.abs + 2, true, animation);
                            // console.log('called updated function');
                        },
                        animationEnded(s) {
                            // s.moveToIdx(s.track.details.abs + 2, true, animation);
                        },
                        slideChanged(s) {
                            let move_to_index = s.track.details.abs;
                            month_slider.moveToIdx(move_to_index);
                        },
                    },
                    [
                        // add plugins here
                    ]
                );
            }
        });
    }
};

export let __hover_for_tooltip = async function () {
    let rounded_selector = '.js--slider-rounded';

    $(rounded_selector).hover(
        async function (event) {
            $(this).siblings().addClass('show');
        },
        async function (event) {
            $(this).siblings().removeClass('show');
        }
    );
};

let __slider_highlight_navigation = async function (slider) {
    let highlight_selector = '.js--slider-rounded';

    $(highlight_selector).on('click', async function () {
        let slide_index = parseInt($(this).attr('data-slide-index'));

        // Move to new index
        slider.moveToIdx(slide_index, false, { duration: 800, easing: (t) => t });
    });
};

let __slider_month_navigation = async function (slider) {
    let month_selector = '.js--slider-month';

    $(month_selector).on('click', async function () {
        let month = $(this).attr('data-slide-month');

        let widget = $(this).parentsUntil('.stmnt--widget').parent();

        let slide_items = $(widget[0]).find('.js--month-item[data-month="' + month + '"]');

        if (slide_items.length > 0) {
            let first_item = $(slide_items).first();

            let slide_index = parseInt($(first_item).attr('data-index'));
            // Move to new index
            slider.moveToIdx(slide_index, false, { duration: 800, easing: (t) => t });
        }
    });
};
